import ky from 'ky'
import { httpError } from '../utils/errors'

/**
 * SignupService provides signup API services
 */
class SignupService {

    /**
     * verifyMobile sends a verification code to the passed mobile number.
     * The returned API result contains otpId that identifies the verification attempt
     * @param number
     * @returns {Promise<unknown>}
     */
    verifyMobile = (number) => {
        return new Promise((resolve, reject) => {
            const url = `/api/v2/signup/pt/verify`
            const data = {address: number};
            ky.post(url, {json: data}).json()
                .then(result => resolve(result))
                .catch(error => httpError(error).then(er => reject(er)))
        })
    }

    /**
     * confirmMobile confirms a verification attempt identified by otpId with a code
     * @param verifyId
     * @param code
     * @returns {Promise<unknown>}
     */
    confirmMobile = (verifyId, code) => {
        return new Promise((resolve, reject) => {
            const url = `/api/v2/signup/pt/verify`
            const data = {verifyId, code};
            ky.post(url, {json: data}).json()
                .then(result => resolve(result))
                .catch(error => httpError(error).then(er => reject(er)))
        })
    }

    /**
     * createAccount creates a phonethru account.
     * data is an object with the following properties
     * - firstName
     * - lastName
     * - mobileNumber
     * - mobileVerifyId
     * - password
     * It returns 201 if the account was created successfully
     * @param data
     * @returns {Promise<unknown>}
     */
    createAccount = (data) => {
        return new Promise((resolve, reject) => {
            const url = `/api/v2/signup/pt`
            ky.post(url, {json: data}).json()
                .then(result => resolve(result))
                .catch(error => httpError(error).then(er => reject(er)))
        })
    }

}

// Create a singleton instance of the service to export
const instance = new SignupService();

export default instance;